.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

.label {
  display: flex;
  flex: 1;
  color: #666;
}

.input {
  flex: 2;
  border: 1px solid #999;
  min-width: 0;
  padding: 5px 6px;
}
